import {comparacion, filtros, filtrosProductos} from './state';

export function restablecerComparacion(state) {
    state.comparacion = comparacion();
    state.productos_seleccionados = [];
    state.productos = {data: []};
    state.empresas = [];
    state.comparacion.resultConfig = undefined;
}

export function restablecerFiltros(state) {
    state.filtros = filtros();
}

export function establecerComparaciones(state, comparaciones) {
    state.comparaciones = comparaciones;
}

export function establecerProductoComparaciones(state) {
    state.comparacion.matriz_compatibilidad_productos = state.productos_seleccionados;
}

export function establecerComparacion(state, comparacion) {
    state.comparacion = comparacion;

    state.resultado = null;

    state.productos_seleccionados = [];

    if (comparacion.matriz_compatibilidad_productos) {
        comparacion.matriz_compatibilidad_productos.map(p => {
            const producto = {
                id: p.id_producto,
                nombre: p.producto.nombre,
                fabricante: p.producto.fabricante,
                lista_estado: p.producto.lista_estado,
                pictogramas: p.producto.pictogramas,
                unprincipal: p.producto.u_n.riesgo_principal,
                unsegundario: p.producto.u_n.riesgo_secundario,
                unsegundario1: p.producto.u_n.riesgo_secundario1,
            };

            state.productos_seleccionados.push(producto);
        });

        if (state.productos_seleccionados.length === 2) {
            const matriz_compatibilidad_resultado = comparacion.matriz_compatibilidad_productos[0];

            if (matriz_compatibilidad_resultado.resultados && matriz_compatibilidad_resultado.resultados.length && matriz_compatibilidad_resultado.resultados[0]) {
                state.resultado = matriz_compatibilidad_resultado.resultados[0].pivot;
            }
        }
    }
}

export function establecerEmpresasFiltro(state, empresas_filtro) {
    state.empresas_filtro = empresas_filtro;
}

export function establecerEmpresas(state, empresas) {
    state.empresas = empresas;
}

export function establecerUbicaciones(state, ubicaciones) {
    state.ubicaciones = ubicaciones;
}

export function establecerCargandoDatosSelect(state, cargando_datos_select) {
    state.cargando_datos_select = cargando_datos_select;
}

export function establecerUbicacionesFiltro(state, ubicaciones_filtro) {
    state.ubicaciones_filtro = ubicaciones_filtro;
}

export function establecerIdEmpresaFiltro(state, id_empresa) {
    state.filtros.id_empresa = id_empresa;
}

export function establecerIdUbicacionFiltro(state, id_ubicacion) {
    state.filtros.id_ubicacion = id_ubicacion;
}

export function establecerIdUbicacion(state, id_ubicacion) {
    state.comparacion.id_ubicacion = id_ubicacion;
    state.filtros_productos.id_ubicacion = id_ubicacion;
}

export function establecerAccion(state, accion) {
    state.accion = accion;
}

export function establecerIdUbicacionFiltrosProductos(state, id_ubicacion) {
    state.filtros_productos.id_ubicacion = id_ubicacion;
}

export function establecerFabricantes(state, fabricantes) {
    state.fabricantes = fabricantes;
}

export function establecerProductosSeleccionados(state, producto_seleccionado) {
    const producto = state.productos_seleccionados.findIndex(ps => ps.id === producto_seleccionado.id);

    state.resultado = null;

    if (producto >= 0) {
        state.seleccionar_todos.valor = false;

        state.productos_seleccionados.splice(producto, 1);

        state.productos.data.map(p => {
            if (p.id === producto_seleccionado.id) {
                p.seleccionado = false;
            }
        });
    } else {
        state.seleccionar_todos.valor = state.productos.data.length <= state.productos.data.filter(p => p.seleccionado).length;

        producto_seleccionado.ubicacion = state.ubicacion;

        state.productos_seleccionados.push(producto_seleccionado);
    }
}

export function establecerProductos(state, productos) {
    productos.data.map(p => {
        let producto = state.productos_seleccionados.find(ps => ps.id === p.id);

        p.seleccionado = !!producto;
    });

    state.productos = productos;

    let length = state.productos.data.length;

    state.seleccionar_todos.valor = !!length && length <= state.productos.data.filter(p => p.seleccionado).length;
}

export function seleccionarTodos(state, seleccionado) {

    state.resultado = null;

    if (seleccionado) {
        state.productos.data.map(p => {
            p.seleccionado = seleccionado;

            const producto = state.productos_seleccionados.find(ps => ps.id === p.id);

            if (!producto) {
                p.ubicacion = state.ubicacion;

                state.productos_seleccionados.push(p);
            }
        });
    } else {
        state.productos.data.map(p => {
            p.seleccionado = seleccionado;

            const producto = state.productos_seleccionados.findIndex(ps => ps.id === p.id);

            if (producto >= 0) {
                state.productos_seleccionados.splice(producto, 1);
            }
        });
    }
}

export function establecerUbicacion(state, ubicacion) {
    state.ubicacion = ubicacion;
}


export function restablecerFiltrosProductos(state) {
    state.filtros_productos = filtrosProductos();

    state.filtros_productos.id_ubicacion = state.comparacion.id_ubicacion;

    state.seleccionar_todos.valor = false;

    state.productos = {data: []};
}
